import { useQuery } from '@tanstack/vue-query';
import { QK } from '../consts/query-keys';
import { getMyAccount, getUser } from '../services/api/user/userApi';

export const useGetMyAccount = () => {
    return useQuery({
        queryKey: [QK.ACCOUNT.GET],
        queryFn: async () => {
            return await getMyAccount();
        },
    });
};

export const useQueryGetUserDetailed = (userId: string) => {
    return useQuery({
        queryKey: [QK.USERS.DETAILED, userId],
        queryFn: async () => getUser(userId, { detailed: true }),
        enabled: !!userId,
        // The detailed response embeds the user's effective role permissions
        // (access.permissions.role). With the global 5-minute staleTime, a role
        // edited elsewhere would show stale permissions here and could be saved
        // as a personal override. Always refetch on entering the edit-user view
        // so we work against the latest role data.
        staleTime: 0,
        refetchOnMount: 'always',
    });
};
